import { cva, VariantProps } from 'class-variance-authority'

export type TabStyling = VariantProps<typeof tabStyling>

export const tabStyling = cva('text-sm text-gray-800 font-normal text-center text-nowrap px-4 rounded-full py-2', {
  variants: {
    variant: {
      pill: '',
      plain: '',
    },
    isActive: {
      true: '',
      false: '',
    },
    isDisabled: {
      true: 'cursor-not-allowed',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'pill',
      isActive: true,
      class: 'bg-gray-900 text-white shadow-sm',
    },
    {
      variant: 'plain',
      isActive: true,
      class: 'bg-indigo-500 text-white',
    },
    {
      variant: 'pill',
      isActive: false,
      class: 'bg-transparent hover:bg-white hover:text-gray-900',
    },
    {
      variant: 'plain',
      isActive: false,
      class: 'hover:text-gray-900',
    },
  ],
  defaultVariants: {
    variant: 'pill',
    isActive: false,
  },
})
